module.exports = __webpack_public_path__ + "img/logo_lomexin-header.d8db0f80.svg";